import {
  Button,
  CardActions,
  CardContent,
  Grid,
  TextField,
} from "@mui/material";
import React, { FC } from "react";

interface NotificationTestProps {
  token?: string;
  permission?: string;
  isSupported?: boolean;
  requestPermission?: () => void;
  requestPushToken?: () => void;
  lastNotification?: unknown;
  showDialogNotificacoes?: () => void;
}

export const NotificationTest: FC<NotificationTestProps> = ({
  token,
  permission,
  requestPermission,
  requestPushToken,
  lastNotification,
  showDialogNotificacoes,
}) => {
  return (
    <>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Push token"
              value={token}
              multiline
              maxRows={4}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Permissão"
              value={permission}
              multiline
              maxRows={4}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Última notificação"
              value={JSON.stringify(lastNotification)}
              multiline
              maxRows={4}
              InputProps={{ readOnly: true }}
            />
          </Grid>
        </Grid>
      </CardContent>
      <CardActions>
        <Button size="small" onClick={requestPermission} variant="outlined">
          Permitir Notificações
        </Button>
        {permission == "granted" && (
          <Button size="small" onClick={requestPushToken} variant="outlined">
            Get PushToken
          </Button>
        )}
        {permission == "granted" && token && (
          <Button
            sx={{ ml: 1 }}
            size="small"
            variant="outlined"
            onClick={showDialogNotificacoes}
          >
            Enviar Teste
          </Button>
        )}
      </CardActions>
    </>
  );
};
